import * as React from "react";
const SvgDashboard = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11 21H3v-6h8zm10 0h-8V11h8zm-10-8H3V3h8zm10-4h-8V3h8z" }));
export default SvgDashboard;
